import { ActionTree } from 'vuex';
import ApiUrl from '../../../../api/url';
import { RoutineWorkTemplateState } from './types';
import { RootState } from '../../../types';
import * as types from './mutation-types';
import { isHappenedOtherPartyError } from '../../../error-type';

export const actions: ActionTree<RoutineWorkTemplateState, RootState> = {
    /**
     * 業務システム紐付き定常作業テンプレート一覧取得
     * @param {any} dispatch Vuex変数
     * @param {any} commit Vuex変数
     * @param {any} id 業務システムID
     * @param {any} pageNumber ページ番号
     * @param {any} perPage ページ毎の表示件数
     * @param {any} sort ソートするカラムと順番
     * @returns {Promise<void>}
     */
    async search({ dispatch, commit }, { id, pageNumber, perPage, sort } = {}) {
        const payload = {
            page_number: pageNumber,
            per_page: perPage,
            'sort[column]': sort.column,
            'sort[direction]': sort.direction,
            routine_work_enabled: true,
        };
        const templateId = id;
        try {
            commit(types.INDEX_START);
            const resData = await dispatch(
                'auth/api',
                {
                    method: 'get',
                    url: ApiUrl.BusinessSystem.ApplicationTemplate.INDEX.replace(':id', templateId.toString()),
                    params: payload,
                },
                { root: true }
            );
            if (isHappenedOtherPartyError(resData)) {
                // システムエラー・予期せぬエラー時
                commit(types.FATAL_FAILURE);
            } else {
                // 成功時
                commit(types.INDEX_SUCCESS, resData);
            }
        } catch (resData) {
            // アプリケーションエラー時
            commit(types.INDEX_FAILURE, resData.errors[0]);
        }
    },

    /**
     * 画面切り替え時のstoreの消去
     * @param {any} commit Vuex変数
     * @returns {Promise<void>}
     */
    async clearOnBeforeRoute({ commit }) {
        commit(types.CLEAR_ALL);
    },
};
